import React from 'react'
import { Table } from "react-bootstrap";
import storage from "../../../Storage";
import { encode, decode, wait, fixDate } from "../../../Helper";
import C from "../../../Constant";
import socket from "../../../Socket";

export default class Affiliate extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            list: []
        };
    }

    componentDidMount() {
        wait(1700).then(() => {
            this.setState({ loading: false });
        })
        socket.emit(C.MY_AFF, encode({ token: storage.getKey('token') }));
        socket.on(C.MY_AFF, data => this.makeList(data));
    }

    makeList = (data) => {
        //   console.log(data);
        if (data.result === false) {
            this.setState({ loading: false });
        } else {
            this.setState({ loading: false, list: data.result });
        }
    }

    render() {

        const list = this.state.list.map((row, i) =>
            <List key={i} row={row} />
        );


        return (
            <div className="table-responsive">
                {
                    this.state.loading ?
                        <div className="text-center">
                            <div class="spinner-border text-info my-3" role="status" />
                        </div>
                        :
                        <>
                            {list.length === 0 ?
                                <>
                                    You have not introduced anyone yet
                                </>
                                :
                                <Table className={"mb-2"}>
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: 'rgba(16, 185, 129, 0.2)', border: 'none', color: '#fff' }}>
                                                ID
                                            </th>
                                            <th style={{ backgroundColor: 'rgba(16, 185, 129, 0.2)', border: 'none', color: '#fff' }}>
                                                Username
                                            </th>
                                            <th style={{ backgroundColor: 'rgba(16, 185, 129, 0.2)', border: 'none', color: '#fff' }}>
                                                Date
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list}
                                    </tbody>
                                </Table>
                            }
                        </>
                }
            </div>
        );
    }
}



class List extends React.Component {


    render() {

        let { row } = this.props;


        console.log(row.uid);
        return (
            <tr>
                <td>
                    {row.uid}
                </td>
                <td>
                    {row.name}
                </td>
                <td>
                    {fixDate(row.created)}
                </td>
            </tr>
        );
    }
}